<template>
  <ViewSaleModal />
  <CreateSaleModal />
  <CancelSaleModal />
  <button
    ref="openViewSaleBySearch"
    type="button"
    class="d-none"
    data-bs-toggle="modal"
    data-bs-target="#ViewSaleModal"
  ></button>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing radius-7">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 radius-7"
    >
      <div class="d-sm-flex align-items-center">
        <a
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          href="#"
          data-bs-toggle="modal"
          data-bs-target="#CreateSaleModal"
        >
          <span class="create-sale-label">Lançar venda</span>
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </a>
      </div>
      <div class="sales-toolbar">
        <input
          v-model="selectedSalesMonth"
          type="month"
          class="form-control shadow-none sales-month-filter"
          @change="changeMonth"
        />
        <div class="sales-search">
          <div class="sales-search-box">
            <input
              v-model="saleSearchInput"
              type="text"
              class="form-control shadow-none"
              placeholder="Buscar venda por valor, vendedor ou data..."
              @input="debouncedFetchSales(saleSearchInput)"
              @focus="showSaleSearchResults = true"
            />
            <div
              v-if="showSaleSearchResults && saleSearchInput.length >= 2"
              class="sales-search-dropdown"
            >
              <div v-if="isLoadingSales" class="sales-search-empty">
                Buscando vendas...
              </div>
              <button
                v-for="sale in getSalesSearchList"
                :key="sale.id"
                type="button"
                class="sale-search-option"
                @mousedown.prevent="selectSaleFromSearch(sale)"
              >
                {{ formatSaleOption(sale) }}
              </button>
              <div v-if="!isLoadingSales && getSalesSearchList.length === 0" class="sales-search-empty">
                Nenhuma venda encontrada
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body p-15 p-sm-20 p-md-25 mt-10">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              >
                Data
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Valor Total
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Qtd. Items
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Vendedor
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Status
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              >
                Ver mais
              </th>
            </tr>
          </thead>
          <tbody>

            <tr v-for="(value, key) in getSalesList" :key="key">
              
              <td class="shadow-none lh-1 fw-medium text-black-emphasis ps-0">
                {{ value.sale_date ? formatDate(value.sale_date) : '-' }}
              </td>

              <td class="shadow-none lh-1 fw-medium">
                {{ value.total ? 'R$ ' + parseFloat(value.total).toFixed(2).replace('.', ',') : '-' }}
              </td>

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ value.quantity_items ? value.quantity_items : '-' }}
              </td>

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ value.user.name ? value.user.name : '-' }}
              </td>

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span :class="getStatusBadge(value.active)">
                  {{ formatStatus(value.active) }}
                </span>
              </td>

              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <button v-on:click="setCurrentViewSale(value)" data-bs-toggle="modal" data-bs-target="#ViewSaleModal" class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button">
                  <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>
                </button>
              </td>

            </tr>
          
          </tbody>
        </table>
      </div>

      <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mt-20">
        <div class="fs-14 text-muted mb-10 mb-sm-0">
          Página {{ currentPage }} de {{ getSalesPagination.last_page || 1 }} —
          Total de {{ getSalesPagination.total || getSalesList.length }} vendas
        </div>
        <nav aria-label="Paginação de vendas">
          <ul class="pagination mb-0">
            <li class="page-item" :class="{ disabled: currentPage <= 1 }">
              <button type="button" class="page-link" @click="goToPage(currentPage - 1)" :disabled="currentPage <= 1">
                Anterior
              </button>
            </li>
            <li class="page-item" :class="{ disabled: currentPage >= getSalesPagination.last_page }">
              <button type="button" class="page-link" @click="goToPage(currentPage + 1)" :disabled="currentPage >= getSalesPagination.last_page">
                Próxima
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>

  </div>
</template>

<script>

import { defineComponent } from "vue";
import { mapGetters, mapActions } from 'vuex';

import ViewSaleModal from './ViewSaleModal.vue';
import CreateSaleModal from './CreateSaleModal.vue';
import CancelSaleModal from './CancelSaleModal.vue';

export default defineComponent({
  name: "SalesList",
  data() {
    const now = new Date();

    return {
      currentPage: 1,
      saleSearchInput: '',
      selectedSalesMonth: `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`,
      showSaleSearchResults: false,
      isLoadingSales: false,
      lastSaleQuery: '',
      saleFetchTimer: undefined,
      pendingSaleQuery: ''
    };
  },
  computed: {
    ...mapGetters([
      'getSalesList',
      'getSalesPagination',
      'getSalesSearchList'
    ])
  },
  components: {
    ViewSaleModal,
    CreateSaleModal,
    CancelSaleModal
  },
  methods: {
    ...mapActions([
      "setCurrentViewSale",
      "setSalesList",
      "setSalesSearchList"
    ]),
    selectedMonthPayload(page = this.currentPage) {
      const [year, month] = this.selectedSalesMonth.split('-');

      return {
        page,
        month: Number(month),
        year: Number(year)
      };
    },
    async changeMonth() {
      this.currentPage = 1;
      this.saleSearchInput = '';
      this.lastSaleQuery = '';
      this.showSaleSearchResults = false;
      await this.setSalesSearchList('');
      await this.loadPage(1);
    },
    formatSaleOption(sale) {
      const date = sale.sale_date ? this.formatDate(sale.sale_date) : '-';
      const total = sale.total ? `R$ ${parseFloat(sale.total).toFixed(2).replace('.', ',')}` : 'R$ 0,00';
      const seller = sale.user?.name ? ` - ${sale.user.name}` : '';
      return `${date} - ${total}${seller}`;
    },
    async fetchSales(query) {
      if (!query || query.length < 2 || query === this.lastSaleQuery) return;

      this.lastSaleQuery = query;
      this.isLoadingSales = true;

      try {
        const [year, month] = this.selectedSalesMonth.split('-');
        await this.setSalesSearchList({
          search: query,
          month: Number(month),
          year: Number(year)
        });
      } catch (error) {
        this.setSalesSearchList('');
      } finally {
        this.isLoadingSales = false;
      }
    },
    debouncedFetchSales(query) {
      this.pendingSaleQuery = query;

      if (this.saleFetchTimer) {
        clearTimeout(this.saleFetchTimer);
      }

      this.saleFetchTimer = window.setTimeout(() => {
        this.fetchSales(this.pendingSaleQuery);
        this.saleFetchTimer = undefined;
      }, 500);
    },
    selectSaleFromSearch(sale) {
      this.showSaleSearchResults = false;
      this.saleSearchInput = '';
      this.lastSaleQuery = '';
      this.setSalesSearchList('');
      this.onSaleSelect(sale);
    },
    onSaleSelect(sale) {
      this.setCurrentViewSale(sale);

      this.$nextTick(() => {
        const trigger = this.$refs.openViewSaleBySearch;

        if (trigger && typeof trigger.click === 'function') {
          trigger.click();
          return;
        }

        const modalEl = document.getElementById('ViewSaleModal');
        if (modalEl && window.bootstrap && window.bootstrap.Modal) {
          const modalInstance = window.bootstrap.Modal.getInstance(modalEl) || new window.bootstrap.Modal(modalEl);
          modalInstance.show();
        }
      });
    },
    async loadPage(page) {
      if (!page || page < 1) {
        page = 1;
      }
      this.currentPage = page;
      await this.setSalesList(this.selectedMonthPayload(page));
    },
    goToPage(page) {
      if (page < 1 || (this.getSalesPagination.last_page && page > this.getSalesPagination.last_page)) {
        return;
      }
      this.loadPage(page);
    },
    formatDate(date) {
      if (!date) return '-';
      const d = new Date(date);
      return d.toLocaleDateString('pt-BR', { 
        day: '2-digit', 
        month: '2-digit', 
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    formatStatus(status) {
      const statusMap = {
        true: 'Concluído',
        false: 'Cancelada',
      };
      return statusMap[status] || status;
    },
    getStatusBadge(status) {
      const badgeMap = {
        true: 'badge bg-success radius-7',
        false: 'badge bg-danger radius-7'
      };
      return badgeMap[status] || 'badge bg-secondary radius-7';
    }
  },
  watch: {
    getSalesPagination: {
      immediate: true,
      handler(newVal) {
        this.currentPage = newVal && newVal.current_page ? newVal.current_page : 1;
      }
    }
  },
  mounted() {
    this.loadPage(1);
  }
});
</script>

<style scoped>
.sales-search {
  margin-top: 12px;
  max-width: 420px;
  position: relative;
  width: 100%;
  z-index: 99;
}

.sales-toolbar {
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  max-width: 600px;
  width: 100%;
}

.sales-month-filter {
  flex: 0 0 160px;
}

.sales-search-box {
  position: relative;
}

.sales-search-dropdown {
  background: #ffffff;
  border: 1px solid #dfe3ea;
  border-radius: 7px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.12);
  left: 0;
  margin-top: 6px;
  overflow: hidden;
  position: absolute;
  right: 0;
  top: 100%;
  z-index: 20;
}

.sale-search-option {
  background: transparent;
  border: 0;
  color: #34324a;
  display: block;
  font-size: 14px;
  padding: 10px 14px;
  text-align: left;
  width: 100%;
}

.sale-search-option:hover,
.sale-search-option:focus {
  background: #00b894;
  color: #ffffff;
}

.sales-search-empty {
  color: #8a8fa3;
  font-size: 14px;
  padding: 10px 14px;
}

@media (max-width: 575.98px) {
  .card-head {
    align-items: center;
    display: flex !important;
    flex-wrap: wrap;
    gap: 10px;
  }

  .card-head > .d-sm-flex {
    flex: 0 0 auto;
    order: 1;
  }

  .sales-toolbar {
    display: contents;
  }

  .sales-search {
    flex: 1 1 0;
    margin-top: 0;
    min-width: 0;
    order: 2;
    width: auto;
  }

  .sales-month-filter {
    flex: 0 0 100%;
    order: 3;
  }

  .create-sale-label {
    display: none;
  }

  .card-head a.default-btn {
    align-items: center;
    display: inline-flex !important;
    justify-content: center;
    min-height: 42px;
    min-width: 44px;
    padding-left: 16px !important;
    padding-right: 16px !important;
  }

  .card-head a.default-btn i {
    margin-left: 0 !important;
  }
}

@media (min-width: 992px) {
  .sales-search {
    margin-top: 0;
  }
}
</style>
